import React from "react";
interface CircleProgressProps {
  value?: number;
  size?: number;
  strokeWidth?: number;
  icon?: React.ReactNode;
  strokeColor?: string;
}
const CircleProgress: React.FC<CircleProgressProps> = ({
  value = 0,
  size = 64,
  strokeWidth = 4,
  icon,
  strokeColor = "orange"
}) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (value / 100) * circumference;
  //#FFD299 #FCE586
  return (
    <div className="flex flex-col items-center space-y-4">
      <div className="relative" style={{width: size, height: size}}>
        {/* Base Circle */}
        <svg className="-rotate-90 transform" width={size} height={size}>
          <circle
            stroke={strokeColor}
            strokeOpacity="0.2"
            fill="transparent"
            strokeWidth={strokeWidth}
            r={radius}
            cx={size / 2}
            cy={size / 2}
          />
          {/* Progress Circle */}
          <circle
            stroke={strokeColor}
            fill="transparent"
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            r={radius}
            cx={size / 2}
            cy={size / 2}
          />
        </svg>
        {/* Icon */}
        <div className="absolute inset-0 flex items-center justify-center">
          {icon || (
            <img
              src="/images/expense_yellow.svg"
              alt="Expense"
              className="h-5 w-5"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default CircleProgress;
